import React, { Component } from 'react';
import '../App.css';

class Domains extends Component {

  colorSelect(query) {
    if (query.available[0] === 'Taken') {
      return ("domain-status is-taken");
    }
    else if ((query.available[0] === 'error')) {
      return ("domains failed");
    }
    else {
      return ("domain-status");
    }
  }

  availabilityIconSelect(query) {
    if (query.available[0] === 'Taken') {
      return ("fa fa-times");
    }
    else if ((query.available[0] === 'error')) {
      return ("fa fa-times");
    }
    else {
      return ("fa fa-check");
    }
  }

  availabilityTextSelect(query) {
    if (query.available[0] === 'Taken') {
      return ("Active");
    }
    else if ((query.available[0] === 'error')) {
      return ("Error");
    }
    else {
      return ("Inactive");
    }
  }

  openOwnerInfo(url) {
    window.open(url, '_blank');
  }

  domainClean(domain) {
    var textSplitted = domain[0].split('.');
    var domainText = textSplitted[0];
    var tld = domain[0].substring(domain[0].indexOf('.')+1);
    if(domainText.length > 16) {
      var shortDomain = domainText.substring(0,15) + '..';
      return(
        <p>
          <span className='DomainName'>{shortDomain}</span>
          <span>.{tld}</span>
        </p>
      )
    }
    else{
      return(
        <p>
          <span className='DomainName'>{textSplitted[0]}</span>
          <span>.{tld}</span>
        </p>
      )
    }
  }

  render() {
    if (Object.keys(this.props.content).length > 0) {
      const inactive = this.props.content.filter((content) => (
        content.available[0] !== 'error' && content.available[0] !== 'Taken'
      ))
      const active = this.props.content.filter((content) => (
        content.available[0] === 'error' || content.available[0] === 'Taken'
      ))
      const results = inactive.concat(active).map((content, i) =>
        (<tr key={i}>
          <td>
            <a href={"http://www." + content.domain} target="_blank">
              <span>{this.domainClean(content.domain)}</span>
            </a>
          </td>
          <td>
            <span className={this.colorSelect(content)}>
              <i className={this.availabilityIconSelect(content)} aria-hidden="true" />
              &nbsp;
               <span className='tableStatus'>{this.availabilityTextSelect(content)}</span>
            </span>
          </td>
        {content.available[0] !== 'error' && content.available[0] !== 'Taken' 
        ? (
          <td>
            <button className="button"
              onClick={() => this.openOwnerInfo('https://www.123-reg.co.uk')}>
              Buy a domain
          </button>
          </td>
        )
        : (
          <td></td>
        )
            
          }
        </tr>));

      return (
        <div className='ResultBox'>
          <table className="ResultTable domain">
            <tbody>
              <tr>
                <th className="name">WEBSITE</th>
                <th className="status">STATUS</th>
                <th className="info"></th>
              </tr>
              {results}
            </tbody>
          </table>
        </div>
      );
    } else {
      return (
        <div className='ResultBox'>
          <table className='ResultTable domain'>
            <tbody>
              <tr>
                <th className="name">WEBSITE</th>
                <th className="status">STATUS</th>
                <th className="info">INFORMATION</th>
              </tr>
              <tr>
                <td>Loading...</td>
                <td>Loading...</td>
                <td>Loading...</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
  }
}

export default Domains;



// WEBPACK FOOTER //
// ./client/src/Engines/Domains.js